import { useState, useCallback, useRef } from 'react'

const useFormModal = initialValues => {
  const initialValuesRef = useRef(initialValues)
  initialValuesRef.current = initialValues

  const [showModal, setShowModal] = useState(false)
  const [editingItem, setEditingItem] = useState(null)
  const [formData, setFormData] = useState(initialValues)

  const openForCreate = useCallback(() => {
    setEditingItem(null)
    setFormData(initialValuesRef.current)
    setShowModal(true)
  }, [])

  const openForEdit = useCallback((item, transformFn) => {
    setEditingItem(item)
    setFormData(transformFn ? transformFn(item) : item)
    setShowModal(true)
  }, [])

  const close = useCallback(() => {
    setShowModal(false)
  }, [])

  const updateField = useCallback((field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }, [])

  const isEditing = editingItem !== null

  return {
    showModal,
    editingItem,
    formData,
    setFormData,
    openForCreate,
    openForEdit,
    close,
    updateField,
    isEditing,
  }
}

export default useFormModal
